"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TuberculosisWorkHistoryQuestions = void 0;
exports.TuberculosisWorkHistoryQuestions = {
    CLOSE_CONTACT: 'CLOSE_CONTACT',
};
//# sourceMappingURL=tuberculosis.js.map